// extracted by mini-css-extract-plugin
export default {"icon":"DocumentPrivacyModal__icon___AOBMo","text":"DocumentPrivacyModal__text___K3Qfx","button":"DocumentPrivacyModal__button___XfvEC"};